import './Experience.css';
import ExpCard from '../cards/ExpCard';
import SchoolIcon from '@mui/icons-material/School';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LanIcon from '@mui/icons-material/Lan';
// import Work from '@mui/icons-material/Work';
import DevicesIcon from '@mui/icons-material/Devices';
import ScienceIcon from '@mui/icons-material/Science';
import DvrIcon from '@mui/icons-material/Dvr';
import TuneIcon from '@mui/icons-material/Tune';

function Experience() {
    return (
      <section className='experience' id='experience'>
        <hgroup>
            <h2>Experience</h2>
            <p>What I've been up to</p>
        </hgroup>

        <div className='flex-wrapper'>
                <ExpCard
                    title='Education'
                    iconOne={<SchoolIcon />}
                    roleOne='Boston College, M.A. Philosophy'
                    dateOne='2026'
                    iconTwo={<SchoolIcon />}
                    roleTwo='Emmanuel College, B.A. Philosophy'
                    dateTwo='2020'
                />
                  <ExpCard
                    title='Certifications'
                    iconOne={<SupportAgentIcon />}
                    roleOne='CompTIA A+'
                    dateOne='2024'
                    iconTwo={<LanIcon />}
                    roleTwo='CompTIA Net+'
                    dateTwo='2024'
                />
                <ExpCard
                    title='Past Work'
                    iconOne={<DevicesIcon />}
                    roleOne='Technology Consultant'
                    dateOne='Jan 2022 - June 2025'
                    iconTwo={<ScienceIcon />}
                    roleTwo='Museum of Science, Boston'
                    dateTwo='March 2015 - Apr 2020'
                />
                <ExpCard
                    title='Current Work'
                    iconOne={<DvrIcon />}
                    roleOne='Systems Administrator'
                    dateOne='June 2025 - Present'
                    iconTwo={<TuneIcon />}
                    roleTwo='Audio - Atlantic Shake'
                    dateTwo='2023 - Present'
                />
        </div>
      </section>
    );
  }

export default Experience;
